import { SVGProps } from "react";

export default function Logo(props: SVGProps<SVGSVGElement>) {
  const { height = 23, width = 20, fill = "#E3592E", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.21354 5.27696L5.63265 4.45796L9.57805 2.17973L14.9426 5.27696L10.9972 7.55519L12.885 8.64597L14.3662 7.79049L16.8304 6.36773L18.7183 5.27696L16.8304 4.18618L14.3662 2.76343L9.57987 0L4.78994 2.76525L2.32566 4.188L0.43777 5.27878L2.32566 6.36956L4.78994 7.79231L9.57987 10.5576L11.4678 9.46678L9.57987 8.37601L4.21536 5.27878L4.21354 5.27696ZM17.27 15.5007L9.57987 19.9404L1.88788 15.5007L0 14.4099V16.5897L4.78994 19.3549L9.57987 22.1202L14.3698 19.3549L19.1597 16.5897V10.5539L17.2719 11.6447L9.5817 16.0844L1.88788 11.6465V9.97204L4.78994 11.6465L9.57987 14.4118L14.3698 11.6465L19.1597 8.88127V6.70154L17.2719 7.79231L9.5817 12.232L1.88788 7.79049L0 6.69971V12.7355L4.78994 15.5007L9.57987 18.266L14.3698 15.5007L17.2719 13.8262V15.5007H17.27Z"
        fill={fill}
      />
    </svg>
  );
}
